import React, { useCallback } from 'react';
import { Box, HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import RouteKey from '../../../routes/key';
import IndividualReportContent from '../../../modules/accessArrangment/components/candidate/IndividualReport/components/IndividualReportContent';

const {
  coordinatorRoot,
  coordinatorAccessArrangementsRequest,
  coordinatorAmendAccessArrangements,
  coordinatorReviewApplication,
} = RouteKey['access-arrangement'].child;
const { accessArrangement } = RouteKey.child;

const useStyles = makeStyles()((theme) => ({
  stepper: {
    position: 'relative',
    left: '-5%',
    marginTop: theme.spacing(9),
  },
}));

interface IndividualReportCoordinatorProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title: string;
}

const IndividualReportCoordinator = ({
  routeSteps,
  activeStep,
  title,
}: IndividualReportCoordinatorProps) => {
  const history = useHistory();
  const location = useLocation<{ amendment?: boolean }>();
  const amendment = location.state?.amendment ?? false;
  const { uuid } = useParams<{ uuid: string }>();
  const { t } = useTranslation();
  const { classes } = useStyles();

  const handleBack = () => {
    if (amendment) {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorAmendAccessArrangements.route}/${uuid}`
      );
    } else {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorAccessArrangementsRequest.route}/${uuid}`
      );
    }
  };

  const onSuccess = useCallback(() => {
    history.push(
      `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorReviewApplication.route}/${uuid}/${amendment ? 'amendment' : 'draft'}`
    );
  }, [history, uuid, amendment]);

  const candidateNameNewApplication =
    localStorage.getItem(`candidateNameNewApplication: ${uuid}`) || '';
  const candidateNameContinueApplication =
    localStorage.getItem(`candidateNameContinueApplication: ${uuid}`) || '';
  const candidateNameAmendmentApplication =
    localStorage.getItem(`candidateNameAmendmentApplication: ${uuid}`) || '';

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <KeyValue
          keyText={t('accessArrangement->>CoordinatorSelectCandidate.CandidateName')}
          valueText={
            amendment
              ? candidateNameAmendmentApplication
              : candidateNameNewApplication || candidateNameContinueApplication
          }
        />
        <Box className={classes.stepper}>
          <Stepper activeStep={activeStep} steps={routeSteps} />
        </Box>
      </HeaderTemplate>
      <IndividualReportContent handleBack={handleBack} onSuccess={onSuccess} amendment={amendment} />
    </>
  );
};

export default IndividualReportCoordinator;
